import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ fontSizes, breakpoints, fontWeights }: Theme) => ({
  title: {
    margin: '0 0 1.5rem',
    paddingRight: '1.5rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      marginBottom: '2rem',
      paddingRight: '0',
      fontSize: '1.75rem',
    },
  },
  text: {
    margin: 0,
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '1.5rem',
    [breakpoints.up('sm')]: {
      marginTop: '2rem',
    },
  },
  paperStyles: {
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    borderRadius: '0.5rem',
    [breakpoints.up('sm')]: {
      paddingTop: '3rem',
      paddingBottom: '3rem',
    },
  },
}));
